import { css } from "@emotion/react";

export const container = css`
  padding: 0 auto;
  display: flex;
  justify-content: center;
`;

export const content = css`
  max-width: 600px;
`;
